export const dict = [
    { label: "Manual", module: "manual", note: '(ฟรี) กรอกเอง', free: true, default: true },
    { label: "SA Gaming", module: "sa", note: 'SA Gaming [VIP]', default: true, },
]

